module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Land Payments")]), _c('br'), _vm._v(" "), (this.isManager() && this.canAccess('finance')) ? _c('el-collapse', {
    attrs: {
      "accordion": "",
      "value": "history"
    }
  }, [(!_vm.readOnly) ? _c('el-collapse-item', {
    attrs: {
      "title": "Make Payment",
      "name": "pay"
    }
  }, [_c('landowner-payment', {
    attrs: {
      "rowData": _vm.site,
      "site-id": _vm.site.id
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "Payment History",
      "name": "history"
    }
  }, [_c('tenancy-statement', {
    attrs: {
      "rowData": _vm.site,
      "site-id": _vm.site.id
    }
  })], 1)], 1) : _c('div', [_c('tenancy-statement', {
    attrs: {
      "rowData": _vm.site,
      "site-id": _vm.site.id
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5573a209"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/finance/tenancy/SiteFinanceTenancy.vue
// module id = 1493
// module chunks = 0